import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiDateTimeFormatOptions } from '@fi-shared/utils';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { IFiObjectEditorInfo } from '@fi-shared/fi-object-editor-info/fi-object-editor-info';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-object-editor-info',
    templateUrl: './fi-object-editor-info.component.html',
    styleUrls: ['./fi-object-editor-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-object-editor-info' },
    standalone: false,
})
export class FiObjectEditorInfoComponent {
    @Input() objectData: IFiObjectEditorInfo;
    @Input() isMatCardTemplate: boolean;

    constructor(
        private sharedActionsBaseService: SharedActionsBaseService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    getDateLabel(date: string): string {
        return this.fiFormatDateService.formatDate(new Date(date), FiDateTimeFormatOptions);
    }

    showUserProfileDialog(userId: number) {
        this.sharedActionsBaseService.openUserViewPopup(userId);
    }
}
